import { IdCategoriesStateDataItem, typeCategoriesFilters } from './dCategoriesReducer'
import { typeRequestPagination } from '../system/constants';
import { apiClient } from 'model/axiosConfig';

// Type
export type typeCategoriesRequestFilters = {
    filters: {
        name?: string | string[] | null,
        deleted?: boolean | null,
    },
    pageFilter?: typeRequestPagination,
    sortFilter?: {
        direction: string,
        column: string
    }
}


// Get category list
export const getCategoriesList = async (payload: { filters?: typeCategoriesFilters, paginationRequest?: typeRequestPagination}) => {

    const path = '/product/category/search'
    const config = {
        headers: {},
    }
    const data: typeCategoriesRequestFilters = {
        filters: {
        },
        pageFilter: payload.paginationRequest? payload.paginationRequest : undefined,
        sortFilter: {
            direction: "ASC",
            column: "name"
        }
    }
    if (payload.filters && payload.filters.name) data.filters.name = [payload.filters.name]
    if(payload.filters && ('deleted' in payload.filters)) data.filters.deleted = payload.filters.deleted

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}


// Get category list slim
export const getCategoriesListSlim = async () => {

    const path = '/product/category/slim'
    const config = {
        headers: {},
        sortFilter: {
            direction: "ASC",
            column: "name"
        }
    }

    try {
        return await apiClient.get(path, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

// Edit category item
export const changeCategoriesItem = async (payload: { dataObject: IdCategoriesStateDataItem}) => {

    const path = '/product/category'
    const config = {
        headers: {},
    }
    const data = payload.dataObject

    try {
        return await apiClient.patch(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

// Add category item
export const addCategoriesItem = async (payload: { dataObject: {id?: string, name: string, active: boolean}}) => {

    const path = '/product/category'
    const config = {
        headers: {},
    }
    const data = payload.dataObject

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}


// Delete category, bulk action
export const deleteCategoriesBulk = async (payload: { bulkIds: string[]}) => {

    const path = '/product/category/delete/bulk'
    const config = {
       headers: {
                'Content-Type': 'application/json'
            }
    }
    const data =  payload.bulkIds

    try {
        return  await apiClient.post(path, data, config)

    } catch (error) {
        console.log(error)
        return error.response
    }
}

//  Bulk Recover categories
export const bulkRecoverCategory = async (payload: { bulkIds: string[] }) => {

    const path = '/product/category/restore/bulk'
    const config = {
        headers: {},
    }
    const data =  payload.bulkIds

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

//search slim , only not deleted category

// Get category list
export const getNotDeletedCategoriesList = async () => {

    const path = '/product/category/search'
    const config = {
        headers: {},
    }
    const data = {
        filters: {
                deleted: false
        },

        sortFilter: {
            direction: "ASC",
            column: "name"
        }
    }
    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}
